import { CandidatePriority } from '../candidate/candidate-priority';

/**
 * Mapping of Pflegias's candidate priorities to tracking priorities for analytics
 */
export const trackPriorityByPriority: Record<CandidatePriority, string> = {
  [CandidatePriority.A]: 'A',
  [CandidatePriority.B]: 'A',
  [CandidatePriority.B1]: 'A',
  [CandidatePriority.B2]: 'A',
  [CandidatePriority.B3]: 'A',
  [CandidatePriority.B4]: 'A',
  [CandidatePriority.B5]: 'A',
  [CandidatePriority.B6]: 'A',
  [CandidatePriority.C]: 'B',
  [CandidatePriority.C1]: 'B',
  [CandidatePriority.C2]: 'B',
  [CandidatePriority.C3]: 'B',
  [CandidatePriority.D]: 'B',
  [CandidatePriority.D1]: 'B',
  [CandidatePriority.D2]: 'B',
  [CandidatePriority.D3]: 'B',
  [CandidatePriority.E]: 'C',
  [CandidatePriority.E1]: 'C',
  [CandidatePriority.E2]: 'C',
  [CandidatePriority.E3]: 'C',
  [CandidatePriority.F]: 'C',
  [CandidatePriority.F1]: 'C',
  [CandidatePriority.F2]: 'C',
};
